/**
 * Component that passes the desired feature flag's current and previous
 * variation values into a render function passed as a prop
 */
import PropTypes from 'prop-types';

const propTypes = {
  flags: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  flagKey: PropTypes.string.isRequired,
  defaultValue: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  render: PropTypes.func.isRequired,
};

function FlagVariation({ flags, flagKey, defaultValue, render }) {
  const val = flags ? flags[flagKey] : null;
  let current = val && Object.prototype.hasOwnProperty.call(val, 'current') ? val.current : val;
  current =
    (current === null || current === undefined) && defaultValue !== undefined
      ? defaultValue
      : current;
  const previous =
    val && Object.prototype.hasOwnProperty.call(val, 'previous') ? val.previous : undefined;
  return render(current, previous);
}

FlagVariation.propTypes = propTypes;

export default FlagVariation;
